export const diffDate = (d1: Date, d2: Date) => {

    let time1 = d1.getTime();
    let time2 = d2.getTime();

    if (time1 < time2) {
        return -1;
    } else if (time1 > time2) {
        return 1;
    } else {
        return 0;
    }
};